import { noop } from '@mindtickle/utils';
import { AdvanceLinkProps } from '../../type';

const ReloadLink = ({ url, children, className, onClick = noop }: AdvanceLinkProps) => {
  const onClickHandler = () => {
    onClick();
  };

  return (
    <a href={url} className={className} onClick={onClickHandler}>
      {children}
    </a>
  );
};

export default ReloadLink;
